import styled from 'styled-components';
import { Button, Select, Switch, Input } from 'antd';

export const StyledSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledSectionHeader = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledNamesRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledRemoveButton = styled(Button)`
  align-self: center;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledFieldLabel = styled.div`
  font-weight: 300;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledFacilityColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.space_1};
`;

export const StyledAddressSummary = styled.div`
  /* Override LocationSummary's internal hardcoded styles */
  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .ant-form-item,
  p {
    font-size: ${({ theme }) => theme.font.size.xsmall} !important;
    font-weight: 400;
    margin-bottom: ${({ theme }) => theme.spacing.space_1} !important;
  }
`;

export const StyledSwitchRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.space_2};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledSwitch = styled(Switch)``;

export const StyledAddonInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-input-group-addon {
    font-weight: 500;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledFieldRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledTestReportSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_4};
`;
